import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchAll(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/store/receipts', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchOne(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/store/receipts/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    add(ctx, receiptData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/store/receipts', receiptData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    edit(ctx, receiptData) {
      return new Promise((resolve, reject) => {
        const url = `/store/receipts/${receiptData.id}`
        axios
          .put(url, receiptData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    del(ctx, id) {
      return new Promise((resolve, reject) => {
        const url = `/store/receipts/${id}`
        axios
          .delete(url)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

  },
}
